import { Slide, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { snackbarAction } from 'redux/settings/action';
import { getSettingsSnackbar } from 'redux/settings/reducer';

function TransitionUp(props) {
	return <Slide {...props} direction={'bottom'} />;
}

const Alert = React.forwardRef(function Alert(props, ref) {
	return <MuiAlert elevation={1} ref={ref} variant="filled" style={{ width: true }} {...props} />;
});

const CustomSnackbar = (props) => {
	const snackbar = useSelector(getSettingsSnackbar);
	const dispatch = useDispatch();

	const handleClose = () => {
		dispatch(
			snackbarAction({
				autoHideDuration: snackbar?.autoHideDuration || 3000,
				message: snackbar?.message || '',
				severity: snackbar?.severity || 'info',
				open: false,
			}),
		);
	};

	const handleSnackClose = (_ev, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		handleClose();
	};

	return (
		<Snackbar
			open={snackbar?.open}
			autoHideDuration={snackbar?.autoHideDuration}
			onClose={handleSnackClose}
			TransitionComponent={TransitionUp}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'center',
			}}
			key={TransitionUp ? TransitionUp.name : ''}
			{...props}
		>
			<Alert sx={{ width: '100%' }} onClose={handleClose} severity={snackbar?.severity}>
				{snackbar?.message}
			</Alert>
		</Snackbar>
	);
};

export default CustomSnackbar;
